// extracted by mini-css-extract-plugin
export default {"root":"AdmarktRegistrationStepContact-root","columns":"AdmarktRegistrationStepContact-columns","column":"AdmarktRegistrationStepContact-column"};